@if (embeddings.length > 0) {
  <div class="embedding-header">
    <h3>Source Embeddings Information</h3>
  </div>
}

<div class="embeddings-container">
  @for (embedding of embeddings; track embedding; let i = $index) {
    <div class="embedding-item">
      <!-- Source ID and status header -->
      <div class="embedding-header-row">
        <div class="embedding-id">Embedding #{{ i + 1 }}</div>
        <div class="status-badge" [ngClass]="getStatusClass(embedding.status)">
          {{ embedding.status }}
        </div>
      </div>
      <!-- Content section with summary -->
      <div class="info-section full-width">
        <h4>Content</h4>
        <div class="content-text">{{ embedding.content }}</div>
        @if (embedding.summary) {
          <div class="summary-text">
            <h5>Summary</h5>
            <p>{{ embedding.summary }}</p>
          </div>
        }
      </div>
      <div class="two-col-container">
        <!-- Keywords section on left -->
        @if (embedding.keywords && embedding.keywords.length > 0) {
          <div class="info-section">
            <h4>Keywords</h4>
            <div class="keywords-container">
              <mat-chip-listbox aria-label="Keywords" [selectable]="false">
                @for (keyword of embedding.keywords; track keyword) {
                  <mat-chip-option [selectable]="false">
                    {{ keyword }}
                  </mat-chip-option>
                }
              </mat-chip-listbox>
            </div>
          </div>
        }
        <!-- Information section on right -->
        <div class="info-section">
          <h4>Information</h4>
          <div class="info-content">
            <div class="date-grid">
              @if (embedding.publicationDate) {
                <div class="date-item">
                  <span class="date-label">Publication Date:</span>
                  <span>{{ formatDate(embedding.publicationDate) }}</span>
                </div>
              }
              @if (embedding.expirationDate) {
                <div class="date-item">
                  <span class="date-label">Expiration Date:</span>
                  <span>{{ formatDate(embedding.expirationDate) }}</span>
                </div>
              }
            </div>
            <div class="section-divider"></div>
            <!-- References button -->
            <div class="reference-section">
              <button (click)="openReferenceModal(embedding)" mat-flat-button color="accent">
                References
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Embedding separator (except after the last one) -->
      @if (i < embeddings.length - 1) {
        <div class="embedding-separator"></div>
      }
    </div>
  }
</div>

<!-- Loading state -->
@if (isLoadingEmbeddings) {
  <div class="loading-embeddings">
    <div class="spinner-container">
      <mat-spinner diameter="40"></mat-spinner>
      <p>Loading embeddings...</p>
    </div>
  </div>
}

<!-- No data state (only show when not loading and no embeddings) -->
@if (!isLoadingEmbeddings && embeddings.length === 0) {
  <div class="no-data">
    <p>No embedding data available for this source.</p>
  </div>
}
